import getApiClient from '../apiClient';

/**
 * @typedef {import('./types').TenantConfiguration} TenantConfiguration
 */

/**
 * Fetches tenant configuration for a given outlet
 * @param {string} outletId - The outlet ID
 * @param {string} [baseUrl] - Optional base URL for the API
 * @returns {Promise<TenantConfiguration>} - Promise resolving to the tenant configuration
 */
export async function getTenantConfig(outletId, baseUrl) {
  const apiClient = getApiClient(baseUrl);
  const { data } = await apiClient.get(`/tenants/${outletId}/config`);
  return data;
}
